import React from 'react';
import {
    Route, RouterProvider, createBrowserRouter, createRoutesFromElements,
} from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { PUBLIC_URLS } from 'services/urls';
import DirectSignUpPage from 'views/public/SignUp/DirectSignUpPage/DirectSignUpPage';
import { SignUpProvider } from './views/public/SignUp/SignUpContext';
import SignUp from './views/public/SignUp/SignUp';
import NotFound from './views/public/NotFound/NotFound';
import { config } from './config';

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route
                path={PUBLIC_URLS.SIGN_UP.LANDING_PAGE}
                element={(
                    <SignUpProvider>
                        <SignUp />
                    </SignUpProvider>
                )}
            />
            <Route
                path={PUBLIC_URLS.SIGN_UP.DIRECT_SIGN_UP}
                element={(
                    <DirectSignUpPage />
                )}
            />
            <Route path="*" element={<NotFound />} />
        </>,
    ),
    {
        future: {
            v7_relativeSplatPath: true,
        },
    },
);

const PublicAppRouter: React.FC = () => (
    <GoogleReCaptchaProvider reCaptchaKey={config.googleCaptchaApiKey}>
        <RouterProvider router={router} />
    </GoogleReCaptchaProvider>
);

export default PublicAppRouter;
